import { BankSessionsAction } from '../../actions/consumerDataPullSessionActions/bankSessionActions'
import { BankError, BankSession } from '#modules/Bank/Bank.types'

export enum BankSessionStatus {
	IDLE = 'idle',
	FETCHING = 'fetching',
	FETCH_SUCCESS = 'fetchSuccess',
	FETCH_FAILURE = 'fetchFailure',

	CREATING = 'creating',
	CREATE_SUCCESS = 'createSuccess',
	CREATE_FAILURE = 'createFailure',
}

export interface BankSessionState {
	status: BankSessionStatus
	error?: BankError
	bankSessions?: BankSession[]
	emptyListOfAccountsReceived: boolean
}

export const INITIAL_STATE: BankSessionState = {
	status: BankSessionStatus.IDLE,
	emptyListOfAccountsReceived: false,
}

export function idleBankSessionsReducer(
	state: BankSessionState,
	action: BankSessionsAction,
): BankSessionState {
	switch (action.type) {
		case 'transactionClientApp/bankSessions/getAll':
			return {
				...state,
				status: BankSessionStatus.FETCHING,
			}
		case 'transactionClientApp/bankSessions/create':
			return {
				...state,
				status: BankSessionStatus.CREATING,
			}
		case 'transactionClientApp/bankSessions/getAllSuccess':
			return {
				...state,
				status: BankSessionStatus.FETCH_SUCCESS,
				bankSessions: action.payload.bankSessions,
			}
		default:
			return state
	}
}

export function fetchingBankSessionsReducer(
	state: BankSessionState,
	action: BankSessionsAction,
): BankSessionState {
	switch (action.type) {
		case 'transactionClientApp/bankSessions/getAllSuccess':
			return {
				...state,
				status: BankSessionStatus.FETCH_SUCCESS,
				bankSessions: action.payload.bankSessions,
			}
		case 'transactionClientApp/bankSessions/getAllFailure':
			return {
				...state,
				status: BankSessionStatus.FETCH_FAILURE,
			}
		default:
			return state
	}
}

export function fetchBankSessionsSuccessReducer(
	state: BankSessionState,
	action: BankSessionsAction,
): BankSessionState {
	switch (action.type) {
		case 'transactionClientApp/bankSessions/getAll':
			return {
				...state,
				status: BankSessionStatus.FETCHING,
			}
		case 'transactionClientApp/bankSessions/create':
			return {
				...state,
				status: BankSessionStatus.CREATING,
			}
		case 'transactionClientApp/bankSessions/getAllSuccess':
			return {
				...state,
				status: BankSessionStatus.FETCH_SUCCESS,
				bankSessions: action.payload.bankSessions,
			}
		default:
			return state
	}
}

export function fetchBankSessionsFailureReducer(
	state: BankSessionState,
	action: BankSessionsAction,
): BankSessionState {
	switch (action.type) {
		case 'transactionClientApp/bankSessions/getAll':
			return {
				...state,
				status: BankSessionStatus.FETCHING,
			}
		case 'transactionClientApp/bankSessions/create':
			return {
				...state,
				status: BankSessionStatus.CREATING,
			}
		default:
			return state
	}
}

export function creatingBankSessionsReducer(
	state: BankSessionState,
	action: BankSessionsAction,
): BankSessionState {
	switch (action.type) {
		case 'transactionClientApp/bankSessions/createSucceeded':
			return {
				...state,
				status: BankSessionStatus.CREATE_SUCCESS,
				bankSessions: undefined,
				emptyListOfAccountsReceived: action.payload.accounts.length === 0,
			}
		case 'transactionClientApp/bankSessions/createFailed':
			return {
				...state,
				status: BankSessionStatus.CREATE_FAILURE,
				error: action.payload,
			}
		default:
			return state
	}
}

export function createBankSessionsSuccessReducer(
	state: BankSessionState,
	action: BankSessionsAction,
): BankSessionState {
	switch (action.type) {
		case 'transactionClientApp/bankSessions/create':
			return {
				...state,
				status: BankSessionStatus.CREATING,
			}
		case 'transactionClientApp/bankSessions/getAll':
			return {
				...state,
				status: BankSessionStatus.FETCHING,
			}
		case 'transactionClientApp/bankSessions/getAllSuccess':
			return {
				...state,
				status: BankSessionStatus.FETCH_SUCCESS,
				bankSessions: action.payload.bankSessions,
			}
		default:
			return state
	}
}

export function createBankSessionsFailureReducer(
	state: BankSessionState,
	action: BankSessionsAction,
): BankSessionState {
	switch (action.type) {
		case 'transactionClientApp/bankSessions/create':
			return {
				...state,
				status: BankSessionStatus.FETCHING,
			}
		case 'transactionClientApp/bankSessions/getAll':
			return {
				...state,
				status: BankSessionStatus.FETCHING,
			}
		case 'transactionClientApp/bankSessions/clearErrors':
			return {
				...state,
				error: undefined,
				status: BankSessionStatus.IDLE,
				emptyListOfAccountsReceived: false,
			}
		default:
			return state
	}
}

export default function reduce(
	state: BankSessionState = INITIAL_STATE,
	action: BankSessionsAction,
): BankSessionState {
	switch (state.status) {
		case BankSessionStatus.IDLE:
			return idleBankSessionsReducer(state, action)

		case BankSessionStatus.FETCHING:
			return fetchingBankSessionsReducer(state, action)
		case BankSessionStatus.FETCH_SUCCESS:
			return fetchBankSessionsSuccessReducer(state, action)
		case BankSessionStatus.FETCH_FAILURE:
			return fetchBankSessionsFailureReducer(state, action)

		case BankSessionStatus.CREATING:
			return creatingBankSessionsReducer(state, action)
		case BankSessionStatus.CREATE_SUCCESS:
			return createBankSessionsSuccessReducer(state, action)
		case BankSessionStatus.CREATE_FAILURE:
			return createBankSessionsFailureReducer(state, action)
		default:
			//	TODO log as error
			return state
	}
}
